type TableHeadCellProps = {
  name: string;
  children: any;
  sort?: { sortBy?: string; sortDirection?: number };
  onSort?: (sort: { sortBy?: string; sortDirection?: number }) => void;
};

const TableHeadCell = (props: TableHeadCellProps) => {
  const isSortedBy = props.sort?.sortBy === props.name;
  const isNegative = isSortedBy && props.sort?.sortDirection === -1;

  return (
    <td
      className="py-3 px-6 cursor-pointer space-x-1"
      onClick={() => {
        if (!props.onSort) return;

        if (isNegative) {
          props.onSort({ sortBy: undefined, sortDirection: undefined });
          return;
        }
        props.onSort({
          sortBy: props.name,
          sortDirection: isSortedBy ? (props.sort?.sortDirection === 1 ? -1 : 1) : 1,
        });
      }}
    >
      {isSortedBy ? props.sort?.sortDirection === 1 ? <MiniArrowDown /> : <MiniArrowUp /> : ''}
      <span>{props.children}</span>
    </td>
  );
};

const MiniArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 inline">
    <path
      fillRule="evenodd"
      d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
      clipRule="evenodd"
    />
  </svg>
);

const MiniArrowUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 inline">
    <path
      fillRule="evenodd"
      d="M10 18a.75.75 0 01-.75-.75V4.66L7.3 6.76a.75.75 0 11-1.1-1.02l3.25-3.5a.75.75 0 011.1 0l3.25 3.5a.75.75 0 01-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0110 18z"
      clipRule="evenodd"
    />
  </svg>
);

export default TableHeadCell;
